import HTJ2AuthorizationCard from 'ui/ManagerHTJ2SystemAuthorization/HTJ2AuthorizationCard'

const Htj2IntegrationCard = ({ selectedManager }) => {
	return (
		<div className="full-width">
			<HTJ2AuthorizationCard
				selectedManager={selectedManager}
				context="manager"
			/>
		</div>
	)
}

export default Htj2IntegrationCard
